const formatNumberToPrice = (num = 0) => Math.round(num * 100) / 100

export function addDashesToNumber(number) {
  if (!number) return number

  return `${number.slice(0, 3)}-${number.slice(3, 6)}-${number.slice(6)}`
}

export default formatNumberToPrice
